import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FavoriteService } from '@icullen/api/shared';

@Component({
  selector: 'icullen-favorite',
  templateUrl: './favorite.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./favorite.component.scss']
})
export class FavoriteComponent implements OnInit {

  @Input() isFavoriteDoc:boolean=false;
  @Input() uniqueNumber:string='';
  @Output() favoriteChanged = new EventEmitter<boolean>();

  constructor(
    private favoriteService: FavoriteService,
    private ref: ChangeDetectorRef,
    ) { }

  ngOnInit(): void {
   
    this.isFavoriteDoc=this.favoriteService.isFavorite(this.uniqueNumber);
   // console.log(this.uniqueNumber + this.isFavoriteDoc);
  }

  toggleFavorite(){
    
    if(this.isFavoriteDoc){
      this.favoriteService.removeFavorite(this.uniqueNumber)
      .subscribe(
        data => {
          if(data){
            this.isFavoriteDoc=false;
            this.favoriteService.deleteFavoriteFromArray(this.uniqueNumber);
            this.favoriteChanged.emit(false);
            this.ref.detectChanges();
          }else{
            console.log("remove fav not successful");
          }
        }
      );
      
    }else{
      this.favoriteService.addFavorite(this.uniqueNumber)
      .subscribe(
        data => {
          if(data){
            this.isFavoriteDoc=true;
            this.favoriteService.addFavoriteToArray(this.uniqueNumber);
            this.favoriteChanged.emit(true);
            this.ref.detectChanges();
          }else{
            console.log("add fav not successful");
          }
        }
      );
    }
  }

}
